(function (scope) {
	scope.tweenDurationVeryQuick = 0.25;
	scope.tweenEaseVeryQuick = Sine.easeInOut;
	scope.tweenDurationQuick = 0.5;
	scope.tweenEaseQuick = Sine.easeInOut;
	scope.tabletLandscapePixelWidth = 1024;
	scope.tabletPortraitPixelWidth = 768;
	scope.mobilePortraitPixelWidth = 640;
	scope.HopeStreetSite = function (options) {
		var me = this;
		me._isCSSDisabled;
		me._header;
		me.init = function () {
			new DisableBlankAHREFHashClicks ();
			new PageHashAnchors ({
				isUpdateURLHashOnScroll: options.isUpdateURLHashOnScroll
			});
			// content with JS
			me._header = new Header ();
			new Footer ();
			new HeroBanner ();
			// me.initDonorBox ();
			// new FormsMailChimp ();
			new SocialMediaShareEmail ();

			// catch other content not inited above
			me.initClickCloseOpens ();
			me.initCarousels ();

			// resize home page bands
			new HomePageBanner ();

			// global scripts
			new FadeInOnScroll ();
			me.initEmbedSVGs ();
			// new DisableCSS ();

			// make site visible
			$("#hopestreet-viewport").css ("visibility", "visible");
		};
		me.onInitDeferredSSs = function () {
			me.initEmbedSVGs ();/* do this again in case any deferred SS have 'embed-svg-*' in them */
			new DisableCSS ();
		};
		me._carousels;
		me.initCarousels = function () {
			me._carousels = [];
			$(".owl-carousel").each (function () {
				me._carousels.push (new Carousel (this));
			});
		};
		me._clickCloseOpens;
		me.initClickCloseOpens = function () {
			me._clickCloseOpens = [];
			$(".page a.click-close-open").each (function () {
				me._clickCloseOpens.push (new ClickCloseOpen (this));
			});
		};
		me.embedSVGs;
		me.initEmbedSVGs = function () {
			me.embedSVGs = [];
			$(".embed-svg-replace,.embed-svg-insert,.embed-svg-prepend").each (function () {
				me.embedSVGs.push (new EmbedSVG (this));
			});
		};
		me.initDonorBox = function () {
			var options = {
				onDonorBoxScroll: function () {
					me._header.hide ();
				}
			};
			new FormsDonorBox (options);
		};
		me._formsMailChimp;
		me.initDeferredSSs = function () {
			// initDeferedSSs () is triggered after all deferred SS have been embedded
			// see HeadJS.ss
			me.initDonorBox ();
			me._formsMailChimp = new FormsMailChimp ();
			me.onInitDeferredSSs ();
		};
		me.init ();
	}
}) (window);

//Returns a function, that, when invoked, will only be triggered at most once
//during a given window of time. Normally, the throttled function will run
//as much as it can, without ever going more than once per `wait` duration;
//but if you'd like to disable the execution on the leading edge, pass
//`{leading: false}`. To disable execution on the trailing edge, ditto.
//taken and modified from https://github.com/jashkenas/underscore
var throttle = function(func, wait, options) {
 var timeout, context, args, result;
 var previous = 0;
 if (!options) options = {};

 var later = function() {
     previous = options.leading === false ? 0 : Date.now || function() { return new Date().getTime(); };
     timeout = null;
     result = func.apply(context, args);
     if (!timeout) context = args = null;
 };

 var throttled = function() {
     var now = Date.now || function() { return new Date().getTime(); };
     if (!previous && options.leading === false) previous = now;
     var remaining = wait - (now - previous);
     context = this;
     args = arguments;
     if (remaining <= 0 || remaining > wait) {
         if (timeout) {
             clearTimeout(timeout);
             timeout = null;
         }
         previous = now;
         result = func.apply(context, args);
         if (!timeout) context = args = null;
     } else if (!timeout && options.trailing !== false) {
         timeout = setTimeout(later, remaining);
     }
     return result;
 };

 throttled.cancel = function() {
     clearTimeout(timeout);
     previous = 0;
     timeout = context = args = null;
 };

 return throttled;
};
